import { Role } from '../interfaces/User';
import { useGetQuery } from './useGetQuery';

interface GetRolesParams {
    search?: string;
    page: number;
    size: number;
}

export const useBusinessRoles = (params: GetRolesParams) => {
    const { isLoading, entries, refetch, paging } = useGetQuery<{
        data: Role[];
    }>({
        url: '/roles',
        cacheKey: 'business-roles',
        params: { ...params }
    });

    return { isLoading, businessRoles: entries.data || [], refetch, paging };
};
